import React from 'react';

import { Flex } from '@chakra-ui/react';

import { NoGoalsTimeline } from 'assets/assetsV1/iconComponents/NoGoalsTimeline';

import { TextBodyMedium } from 'uiToolkitV1/Typography';

const MeshMavenError = ({ errorText }) => (
  <Flex flexDir="column" alignItems="center" padding={6}>
    <NoGoalsTimeline boxSize="72px" />
    <TextBodyMedium bold mt={4} mb={3} color="functional.C62C02">
      {errorText}
    </TextBodyMedium>
    <TextBodyMedium color="text.g2">
      {errorText === 'Uh-oh! Looks like an unknown error happened.'
        ? 'You can try clicking on Reanalyze again or contact our support team.'
        : 'You can try adding more information and clicking on Reanalyze.'}
    </TextBodyMedium>
  </Flex>
);

export default MeshMavenError;
